// removed by extract-text-webpack-plugin
module.exports = {"chartWrapper":"src-components-Chart----index-module---chartWrapper---LiLj4","chartWrapperReady":"src-components-Chart----index-module---chartWrapperReady---3a9MM src-components-Chart----index-module---chartWrapper---LiLj4","footer":"src-components-Chart----index-module---footer---2-eJP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/index.module.css
// module id = 598
// module chunks = 168707334958949